// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Vbdd","newExpiryDate":"styles_newExpiryDate__1_SCm","footer":"styles_footer__3SmCl"};